import moment from 'moment'
import { POSTAL_CODE_START_BY_PROVINCE } from 'utils/constants'

export const isValid = value =>
  value === 0 || value === false || (typeof value === 'string' ? value.trim().length > 0 : value)

const postalCodeRegex = /^[A-Z]{1}[0-9]{1}[A-Z]{1}\s?[0-9]{1}[A-Z]{1}[0-9]{1}$/

export const isPostalCode = value => {
  return !value || postalCodeRegex.test(value)
}

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const isEmail = value => {
  return !value || emailRegex.test(value)
}

export const minLength = min => value => {
  if (!value || value.length >= min) return true
  return false
}

export const minPasswordLength = minLength(8)

export const match = (value, { password }) => {
  if (!value || password === value) return
  return 'Passwords must match.'
}

const dateRegex = /^\d{8}$/
const addSlashesToDate = value => value.slice(0, 4) + '/' + value.slice(4, 6) + '/' + value.slice(6, 8)

export const dobIsValid = () => value => {
  if (!value) return false
  const normalizeAge = value.replace(/\//g, '')
  if (!dateRegex.test(normalizeAge)) return false
  const dateWithSlashes = addSlashesToDate(normalizeAge + '')
  const dob = new Date(dateWithSlashes)
  return dob instanceof Date && isFinite(dob) && moment(dob).isBefore(moment())
}

export const isPostalCodeValid = ({ province, postalCode }) => {
  if (!isPostalCode(postalCode)) return false
  const provinceLetters = Object.entries(POSTAL_CODE_START_BY_PROVINCE).find(([, pcLetters]) =>
    pcLetters.includes(postalCode[0])
  )
  if (!provinceLetters) return false
  return !province || province === provinceLetters[0]
}

export const isAddressIncomplete = values => () => {
  const { province, city, country, postalCode, skip } = values
  if (skip) return true

  return isValid(province) && isValid(city) && isValid(country) && isValid(postalCode)
}

export const isValidCreditCardNumber = value => {
  if (!value) return true
  return /^(\d{4}[- ]){3}\d{4}|\d{16}$/.test(value)
}

export const isValidExpiryDate = value => {
  if (!value) return true
  return /\d{2}\/?\d{2}(\d{2})?/.test(value)
}

export const isOutOfRangeExpiryData = value => {
  if (!value) return true
  const digitsOnly = value.replace(/\D/g, '')
  const month = Number(digitsOnly.slice(0, 2))
  return !(month > 12 || month < 1)
}

export const isInThePastExpiryDate = value => {
  if (!value) return true
  const digitsOnly = value.replace(/\D/g, '')
  const month = Number(digitsOnly.slice(0, 2))
  const year = Number(digitsOnly.slice(2, 4))

  const currentMonth = Number(moment().format('MM'))
  const currentYear = Number(moment().format('YY'))

  if (currentYear > year) return false
  if (currentYear === year && currentMonth > month) return false
  return true
}

export const isPhoneNumberValid = value => {
  if (!value) return true
  const formattedPhoneNumber = value.replace(/[^0-9]+/g, '')
  return formattedPhoneNumber.length === 10
}

export const isRetailPinValid = values => value => {
  if (!value) return true
  if (values.retailPin.length !== 5) return false
  return /^\d+$/.test(values.retailPin)
}
